import { render, staticRenderFns } from "./FlowDetail.vue?vue&type=template&id=0bca151c&scoped=true&"
import script from "./FlowDetail.vue?vue&type=script&lang=js&"
export * from "./FlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./FlowDetail.vue?vue&type=style&index=0&id=0bca151c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca151c",
  null
  
)

export default component.exports